import { put, call, take, fork } from 'redux-saga/effects'
import { meService } from '../../api/authentication'
import { authenticationCurrentUserInfoSuccess } from '../../reducers/authentication/action'
import { AUTHENTICATION_CURRENT_USER_INFO } from '../../reducers/authentication/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

import * as amplitude from '@amplitude/analytics-browser'
import HMACObj from 'hmac-obj'

/**
 *
 * @param {*} payload
 */
function* currentUserInfoSagaFlow() {
  try {
    const resMe = yield call(meService)
    window.CONSTANTS = {
      TIME_ZONE: resMe.data.timeZone,
      DATE_FORMAT: resMe.data.dateFormat,
      USER_NAME: resMe.data.userName,
      NAME: resMe.data.name,
      SUR_NAME: resMe.data.surname == null ? '' : resMe.data.surname,
      COMPANY_NAME: resMe.data.companyName,
      COMPANY_LOGO: resMe.data.companyLogo,
      EMAIL: resMe.data.email,
      USER_ROLE_ID: resMe.data.userRoleId,
      CUSTOM_DOMAIN: resMe.data.lastCustomDomain,
      SHOP_ID: resMe.data.shopId,
      ID: resMe.data.userId,
      SECRET_KEY: resMe.data.secretKey,
      PUBLIC_KEY: resMe.data.publicKey,
      IS_TRIAL_EXPIRED: resMe.data.trialExpired,
      TRIAL_DAYS_REMAINING: resMe.data.trialDaysRemaining,
    }

    if (resMe.data.trialExpired && window.location.pathname !== '/trial-expired' && window.location.pathname !== '/purpose') {
      window.location.href = '/trial-expired'
      return
    }

    amplitude.init(process.env.REACT_APP_AMPLITUDE_KEY, resMe.data.userName, {
      serverUrl: `${process.env.REACT_APP_URL}Analytics/Track`,
    })
    if (window.lintrk) {
      window.lintrk('setUserData', { email: resMe.data.userName })
    }
    const identifyEvent = new amplitude.Identify()
    identifyEvent.set('Plan_Type', resMe.data.userRoleString)
    amplitude.identify(identifyEvent)

    const hmacSHA256 = yield HMACObj.new(
      '1kX6aGrFBj9ln90QhCDmNqV9Yt7bGLKcwnHA1kMK',
      resMe.data.userName,
      'SHA-256',
    )

    window.Intercom('boot', {
      api_base: 'https://api-iam.intercom.io',
      app_id: 'a1mmx6vo',
      name: resMe.data.name + ' ' + resMe.data.surname, // Full name
      email: resMe.data.userName, // Email address
      userRole: resMe.data.userRoleString,
      user_hash: hmacSHA256.hexdigest(),
    })

    yield put(authenticationCurrentUserInfoSuccess(resMe.data))
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* currentUserInfoSagaWatcher() {
  while (true) {
    const action = yield take(AUTHENTICATION_CURRENT_USER_INFO)
    const { payload } = action

    yield fork(generalSaga, currentUserInfoSagaFlow, payload)
  }
}
